// extracted by mini-css-extract-plugin
export default {"pager":"pager_pager__tI4ps","next":"pager_next__7HmSl","previous":"pager_previous__1qDrc"};